import { createApi } from './gb-api';

type Api = ReturnType<typeof createApi>;

export const connectGivebutter = async (api: Api): Promise<boolean> => {
  const authorizeUrl = await api.startConnect();

  const popup = window.open(authorizeUrl, 'givebutter-connect', 'width=600,height=860');

  if (!popup) {
    window.location.href = authorizeUrl;
    return false;
  }

  const backendOrigin = new URL(
    import.meta.env.VITE_WIX_APP_GB_API_URL ?? 'https://givebutter.test:3000',
  ).origin;

  return new Promise<boolean>(resolve => {
    let settled = false;

    const finish = (success: boolean) => {
      if (settled) return;
      settled = true;
      window.removeEventListener('message', onMessage);
      clearInterval(closedTimer);
      resolve(success);
    };

    const onMessage = (event: MessageEvent) => {
      if (event.data?.source !== 'givebutter-wix-oauth') {
        return;
      }
      if (event.origin !== backendOrigin) {
        return;
      }
      finish(Boolean(event.data.success));
    };

    window.addEventListener('message', onMessage);

    const closedTimer = setInterval(() => {
      if (popup.closed) {
        clearInterval(closedTimer);
        setTimeout(() => finish(false), 300);
      }
    }, 500);
  });
};
